export const publicRoutes = {
  home: "/",
  services: "/services",
  pricing: "/pricing",
  about: "/about-us",
  contact: "/contact-us",
  blog: "/blog",
  terms: "/terms-of-use",
  privacy: "/privacy-policy",
} as const;

export const authRoute = {
  auth: "/auth",
} as const;

const baseDashboardRoute = "/dashboard";

export const orgPublicRoute = {
  orgHome: "/",
} as const;

export const orgAuthRoute = {
  login: "/auth",
  resendVerification: "/auth/resend-verification",
  verifyBusiness: "/auth/verify-business",
} as const;

export const orgRoutes = {
  dashboard: baseDashboardRoute,
  events: `${baseDashboardRoute}/events`,
  eventChangeRequests: `${baseDashboardRoute}/change-requests`,
  customers: `${baseDashboardRoute}/customers`,
  staffs: `${baseDashboardRoute}/staffs`,
  inventories: `${baseDashboardRoute}/inventories`,
  mealInventory: `${baseDashboardRoute}/inventories/meal`,
  drinkInventory: `${baseDashboardRoute}/inventories/drink`,
  ingredientInventory: `${baseDashboardRoute}/inventories/ingredient`,
  orgMgt: `${baseDashboardRoute}/org-management`,
  settings: `${baseDashboardRoute}/settings`,
} as const;

const baseUserDashboardRoute = "/users/dashboard";

export const userRoutes = {
  dashboard: baseUserDashboardRoute,
  events: `${baseUserDashboardRoute}/events`,
  eventRequests: `${baseUserDashboardRoute}/event-requests`,
  settings: `${baseUserDashboardRoute}/settings`,
} as const;
